import script from "./LoadingContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingContainer.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingContainer.vue?vue&type=style&index=0&id=001f1970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001f1970"]])

export default __exports__